import styled from "styled-components";

const TodosActionsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 3rem;
  color: var(--text-light);
  font-size: 1.3rem;
  padding-top: 2rem;

  & label,
  & .btn-clear {
    transition: all 0.2s;
    &:hover {
      color: var(--text);
    }
  }

  & .todos__filters {
    display: flex;
    gap: 1rem;
    & input {
      appearance: none;
    }
    & label {
      cursor: pointer;
    }

    & input {
      &:checked {
        & ~ label {
          color: var(--bright-blue);
          font-weight: 700;
        }
      }
    }
  }
`;

export default TodosActionsWrapper;
